import { ConfigProvider as ProfgeosoftConfigProvider } from '@profgeosoft-ui/react';
import { ConfigProvider } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { Sidebar } from 'src/components/sidebar/Sidebar';
import { useService } from 'src/packages/di';

import { getLocale } from './router/utils';

export const PagesContainer = observer(function PagesContainer() {
  const theme = useService('theme');
  const language = useService('language');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme.theme);
  }, [theme.theme]);

  return (
    <ConfigProvider
      config={{
        theme: theme.theme,
        style: 'bordered',
        localization: getLocale(language.language),
        size: 's',
      }}
      externalElement={document.body}
    >
      <ProfgeosoftConfigProvider
        config={{
          theme: theme.theme,
          style: 'bordered',
          localization: getLocale(language.language),
          size: 's',
        }}
        externalElement={document.body}
      >
        <Outlet />
        <Sidebar />
      </ProfgeosoftConfigProvider>
    </ConfigProvider>
  );
});
